import { render, staticRenderFns } from "./PTableSimple.vue?vue&type=template&id=769551e4&scoped=true&"
import script from "./PTableSimple.vue?vue&type=script&lang=ts&"
export * from "./PTableSimple.vue?vue&type=script&lang=ts&"
import style0 from "./PTableSimple.vue?vue&type=style&index=0&id=769551e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769551e4",
  null
  
)

export default component.exports